import api from 'api'
import { WorkShift } from 'api/typings'

const ENDPOINTS = {
  detail: '/admin/graphql_dispatch/admin_shift_detail_2fc2e2f7',
  listingTiers: '/admin/graphql_dispatch/admin_shift_listing_tiers_fe7baca0',
  pay: '/admin/graphql_dispatch/admin_shift_pay_871062d4',
} as const

export type LegacyShiftQueryKey = keyof typeof ENDPOINTS

type ShiftResponse = { data: { admin: { shift: WorkShift } } }

export const getLegacyShiftById = async (
  shiftId: WorkShift['id'] | string,
  queryKey: LegacyShiftQueryKey
): Promise<WorkShift> => {
  const response = await api.post<ShiftResponse>(ENDPOINTS[queryKey], {
    shiftId: Number(shiftId),
  })
  return response.data.data.admin.shift
}
